var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.722,
    height: 19.789
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#53b36c",
    "data-name": "Icon feather-check-square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.896 13.26a1.5 1.5 0 0 1-1.061-.439l-2.8-2.8A1.5 1.5 0 1 1 8.156 7.9l1.74 1.739 8.267-8.267a1.5 1.5 0 0 1 2.121 2.121l-9.327 9.327a1.5 1.5 0 0 1-1.061.44",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.424 19.789H3.365A3.37 3.37 0 0 1 0 16.424V3.365A3.37 3.37 0 0 1 3.365 0h10.26a1.5 1.5 0 0 1 0 3H3.365A.366.366 0 0 0 3 3.365v13.059a.366.366 0 0 0 .365.365h13.059a.366.366 0 0 0 .365-.365V9.895a1.5 1.5 0 1 1 3 0v6.529a3.37 3.37 0 0 1-3.365 3.365",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2"
  }))));
};
export default SvgCheckMark;